import { Trans } from 'react-i18next'

import translationKeys from '@translationKeys'

import TruncateLines from '@components/TruncateLines'

import { NoteButtonLabel, StyledNoteButton } from '../index.styles'
import { CellInfo } from '../types'

export const NoteCell = (info: CellInfo) => {
  const {
    row: { original: profileData },
    meta: { onNoteClick },
  } = info

  return (
    <StyledNoteButton
      id="shortlist-note"
      variant="text"
      onClick={e =>
        onNoteClick(e, { profileId: profileData.profileId, note: profileData.note ?? '', profileType: profileData.profileType })
      }
    >
      <TruncateLines lines={5}>
        {profileData.note || (
          <NoteButtonLabel>
            <Trans>{translationKeys.ADD_NOTE_HERE}</Trans>
          </NoteButtonLabel>
        )}
      </TruncateLines>
    </StyledNoteButton>
  )
}
